// src/components/OurPolicy.jsx
import React from 'react';
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  useTheme,
} from '@mui/material';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';

const policies = [
  {
    icon: <LocalShippingOutlinedIcon fontSize="large" color="primary" />,
    title: 'Free Shipping',
    description: 'On all orders over $50',
  },
  {
    icon: <CachedOutlinedIcon fontSize="large" color="primary" />,
    title: 'Easy Returns',
    description: '30-day money-back guarantee',
  },
  {
    icon: <CreditCardOutlinedIcon fontSize="large" color="primary" />,
    title: 'Secure Payments',
    description: 'All payments are processed securely',
  },
  {
    icon: <SupportAgentOutlinedIcon fontSize="large" color="primary" />,
    title: '24/7 Support',
    description: 'Dedicated support from our team',
  },
];

const OurPolicy = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 8, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {policies.map((policy) => (
            <Grid item key={policy.title} xs={12} sm={6} md={3}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  textAlign: 'center',
                  height: '100%',
                  borderColor: theme.palette.divider,
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: theme.shadows[4],
                  },
                }}
              >
                <Box sx={{ mb: 2 }}>{policy.icon}</Box>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {policy.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {policy.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default OurPolicy;
